export const AUTH_REDIRECT_STORAGE_KEY = 'auth-redirect';

export const AUTH_REDIRECT_CALLBACK_PATH = '/login/callback';
